export enum AppEvents {
  CreateRealmSuccess = 'CreateRealmSuccess',
}
